import React, { useEffect, useState, useContext } from "react";
import resa from "../../img/resa2.jpg";
import psychologue from "../../img/psychologue.jpg";
import welcome from "../../img/welcomepoitiers.jpg";
import cms from "../../img/nextjs.jpg";
import grid from "../../img/grid.jpg";
import carousel from "../../img/carousel.jpg";
import "./Realisation.css";
import { ThemeContext } from "../../Context/ThemeContext";
export default function Realisations(props) {
  const loader = document.querySelector(".loader");
  const [count, setCount] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);
  const { fr, en } = useContext(ThemeContext);
  const setLoading = () => {
    setIsLoaded(true);
    props.hideLoader();
  };

  useEffect(() => {
    setLoading();
  }, []);
  return (
    <>
      {isLoaded ? (
        <div className="full_h">
          <div className="bg mt">
            <h2 className="title">
              {fr
                ? "Quelques réalisations personnelles"
                : "Selected work carried out during my personal time"}
            </h2>
            <br />
            <br />
            <div>
              <div>
                <h3>
                  {fr
                    ? "Créateur de sites vitrine NextJS / TypeScript / Neon"
                    : "Creation of a configurable and customisable website using NextJS / TypeScript / Neon"}{" "}
                </h3>
                <br />
                <h4 className="small">
                  {fr
                    ? "Moteur de configuration déclaratif développé en Next.js 15 / TypeScript, permettant à des utilisateurs non techniques de créer et modifier des sites vitrines sans écrire de code. En production depuis janvier 2025, utilisé par l'association Welcome Poitiers. Architecture monolithique modulaire avec état immutable (Immer), validation typée par préfixes sémantiques et pattern Factory. Score Codacy A — CodeScene 9.84/10."
                    : "Declarative configuration engine built with Next.js 15 / TypeScript, enabling non-technical users to create and customize showcase websites without writing code. In production since January 2025, used by the Welcome Poitiers association. Modular monolithic architecture with immutable state (Immer), prefix-based typed validation and Factory pattern. Codacy score A — CodeScene 9.84/10. :"}
                </h4>
                <br />
                <br />
                <div className="flex-wrap">
                  <div data-aos="fade-left" data-aos-id="super-duper">
                    <a
                      href="https://simple-config-cms.vercel.app/"
                      target="_blank"
                    >
                      <img
                        className="full_width"
                        alt="site configurable"
                        src={cms}
                      />
                    </a>
                  </div>
                  <br />
                  <br />
                  <div data-aos="fade-left" data-aos-id="super-duper">
                    <a href="https://welcomepoitiers.fr/" target="_blank">
                      <img
                        className="full_width"
                        alt="configurable website"
                        src={welcome}
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <br />
            <div>
              <div>
                <h3>
                  {fr
                    ? "Architecture Microservices — Recommandation de films"
                    : "Microservices Architecture — Film Recommendation Engine"}{" "}
                </h3>
                <br />
                <h4 className="small">
                  {fr
                    ? "Application de recommandation de films en architecture microservices conteneurisée. Communication asynchrone via Kafka (pattern SAGA), recherche sémantique vectorielle avec pgvector, cache Redis et intégration LLM. Projet en cours de développement."
                    : "Film recommendation app built on a containerized microservices architecture. Asynchronous communication via Kafka (SAGA pattern), semantic vector search with pgvector, Redis caching and LLM integration. Work in progress."}
                </h4>
                <br />
                <div className="align-center">
                  <a className="link" href="https://github.com/Aline86">
                    https://github.com/Aline86
                  </a>
                </div>
                <br />
              </div>
            </div>
            <div className="flex-wrap">
              <div>
                <h3>
                  {fr
                    ? "Création d'une grille CSS JS permettant de conserver le ratio des images - HTML / CSS / JS"
                    : "Creation of a CSS / JavaScript grid that preserves image aspect ratios"}{" "}
                </h3>
                <br />
                <div data-aos="fade-right" data-aos-id="super-duper">
                  <a
                    href="https://github.com/Aline86/grid_ratio_pictures"
                    target="_blank"
                  >
                    <img
                      className="full_width"
                      alt={
                        fr
                          ? "Création d'une grille configurable"
                          : "Creation of a configurable grid"
                      }
                      src={grid}
                    />
                  </a>
                </div>
              </div>
              <div>
                <h3>
                  {fr
                    ? "Création d'un composant de carousel React réutilisable et configurable - React JS"
                    : "Creation of a reusable and configurable React carousel component"}{" "}
                </h3>

                <br />
                <div className="align-center">
                  {" "}
                  <a
                    href="https://github.com/Aline86/composant_carousel_react"
                    target="_blank"
                    className="link"
                  >
                    {fr
                      ? "Voir le code du composant React de carousel"
                      : "See React component carousel code"}{" "}
                  </a>
                </div>
                <br />
                <br />
                <a
                  href="https://composant-carousel-react.vercel.app/"
                  target="_blank"
                >
                  <img
                    className="full_width"
                    alt={
                      fr
                        ? "Lien vers le code du composant React de carousel"
                        : "See the source code for the React carousel component"
                    }
                    src={carousel}
                  />
                </a>
              </div>
              <br />
            </div>
            <div>
              <br />
              <br />
              <h3>
                {fr
                  ? "Lien vers quelques projets Github"
                  : "Link towards a few Github's project"}
              </h3>
              <br />
              <div className="align-center">
                <a className="link" href="https://github.com/Aline86">
                  https://github.com/Aline86
                </a>
              </div>
            </div>
          </div>
        </div>
      ) : (
        props.showLoader()
      )}
    </>
  );
}
